module.exports = __webpack_public_path__ + "static/img/14.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/14.png
// module id = e6vL
// module chunks = 0